import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, createBlock as _createBlock, createCommentVNode as _createCommentVNode, normalizeStyle as _normalizeStyle, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-2519c534"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "profile bg-header" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "container d-none d-lg-flex text-white text-start pt-5 pb-3",
  id: "header"
}, [
  /*#__PURE__*/_createElementVNode("h1", { class: "fw-bold ps-2" }, "Settings")
], -1))
const _hoisted_3 = { class: "container-fluid container-lg" }
const _hoisted_4 = { class: "row d-flex flex-column flex-lg-row" }
const _hoisted_5 = {
  class: "col-auto order-first col-lg-3 pb-3 px-0",
  id: "sideNav"
}
const _hoisted_6 = ["id"]
const _hoisted_7 = ["onClick"]
const _hoisted_8 = { class: "fs-4 d-none d-block d-lg-inline ms-3" }
const _hoisted_9 = {
  class: "col container-fluid d-flex justify-content-center pb-3 mb-5",
  id: "settings"
}
const _hoisted_10 = { class: "container text-white text-start mx-3 mx-sm-5" }
const _hoisted_11 = { class: "settings-header pt-3 pb-2" }
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("hr", { class: "border-lightgreen border-2 opacity-100 mb-0" }, null, -1))
const _hoisted_13 = {
  class: "col-auto d-flex justify-content-center justify-content-lg-start order-first order-lg-last my-4 my-lg-0 me-0 me-lg-5",
  id: "userAvatar"
}
const _hoisted_14 = {
  type: "file",
  class: "d-none",
  accept: "image/png, image/gif, image/jpeg",
  ref: "selectFile"
}
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: "26",
  height: "26",
  fill: "currentColor",
  class: "bi bi-image",
  viewBox: "0 0 16 16"
}, [
  /*#__PURE__*/_createElementVNode("path", { d: "M6.002 5.5a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0z" }),
  /*#__PURE__*/_createElementVNode("path", { d: "M2.002 1a2 2 0 0 0-2 2v10a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V3a2 2 0 0 0-2-2h-12zm12 1a1 1 0 0 1 1 1v6.5l-3.777-1.947a.5.5 0 0 0-.577.093l-3.71 3.71-2.66-1.772a.5.5 0 0 0-.63.062L1.002 12V3a1 1 0 0 1 1-1h12z" })
], -1))
const _hoisted_16 = [
  _hoisted_15
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_EditProfile = _resolveComponent("EditProfile")!
  const _component_SecurityAndLogin = _resolveComponent("SecurityAndLogin")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("ul", {
            class: _normalizeClass(["nav nav-pills w-100 flex-row flex-lg-column flex-nowrap text-center justify-content-around align-items-center mt-0 mt-lg-4", {
              'pb-1 border-bottom border-2 border-lightgreen':
                _ctx.windowWidth >= 992,
            }])
          }, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.tabs, (tab) => {
              return (_openBlock(), _createElementBlock("li", {
                key: `${tab.text.toLowerCase()}`,
                id: `${tab.text.toLowerCase()}Tab`,
                class: _normalizeClass(["nav-item w-100 overflow-hidden mb-0 mb-lg-3", { 'nav-active': _ctx.activeTab === tab.name }])
              }, [
                _createElementVNode("button", {
                  type: "button",
                  class: _normalizeClass(["nav-link nav-highlight w-100 text-white rounded-0", {
                  'text-start': _ctx.windowWidth >= 992,
                  'py-3 px-4 text-center': _ctx.windowWidth < 992,
                }]),
                  onClick: ($event: any) => (_ctx.setActiveTab(tab.name))
                }, [
                  _createElementVNode("em", {
                    class: _normalizeClass(["bi", [tab.icon, _ctx.windowWidth >= 992 ? 'fs-4' : 'fs-2']])
                  }, null, 2),
                  _createElementVNode("span", _hoisted_8, _toDisplayString(tab.text), 1)
                ], 10, _hoisted_7)
              ], 10, _hoisted_6))
            }), 128))
          ], 2)
        ]),
        _createElementVNode("div", _hoisted_9, [
          _createElementVNode("div", _hoisted_10, [
            _createElementVNode("h4", _hoisted_11, _toDisplayString(_ctx.activeTab), 1),
            _hoisted_12,
            (_ctx.activeTab === 'Profile')
              ? (_openBlock(), _createBlock(_component_EditProfile, { key: 0 }))
              : _createCommentVNode("", true),
            (_ctx.activeTab === 'Security and Login')
              ? (_openBlock(), _createBlock(_component_SecurityAndLogin, { key: 1 }))
              : _createCommentVNode("", true)
          ])
        ]),
        _createElementVNode("div", _hoisted_13, [
          _createElementVNode("input", _hoisted_14, null, 512),
          _createElementVNode("div", {
            class: "avatar rounded-circle bg-white position-relative",
            style: _normalizeStyle({
              backgroundImage: `url(${_ctx.setURL(_ctx.avatar)})`,
            })
          }, [
            _createElementVNode("button", {
              type: "button",
              class: "btn bg-secondary rounded-circle position-absolute bottom-0 end-0 d-flex justify-content-center align-items-center p-3",
              id: "changeAvatar",
              onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$refs.selectFile.click()))
            }, _hoisted_16)
          ], 4)
        ])
      ])
    ])
  ]))
}